import { render, staticRenderFns } from "./PaymentDocumentsIndex.vue?vue&type=template&id=6d2f6651&scoped=true&"
import script from "./PaymentDocumentsIndex.vue?vue&type=script&lang=js&"
export * from "./PaymentDocumentsIndex.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDocumentsIndex.vue?vue&type=style&index=0&id=6d2f6651&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f6651",
  null
  
)

export default component.exports